/**
 * Navigation routes constants - simplified
 */
export const NAVIGATION_ROUTES = {
  TEAM_MANAGEMENT: '/team-management',
  VENDORFLOW_DASHBOARD: '/vendorflow-dashboard',
  VENDOR_EMPLOYEE: '/vendor-employee',
  VENDOR_MANAGEMENT_HIRING: '/vendor-management',
  OPS_VENDOR_MANAGEMENT: '/ops-vendor-management',
  ASSET_MANAGEMENT: '/asset-management',
  ISKILL: '/iskill',
  FINANCE: '/finance',
  PRODUCTIVITY: '/productivity',
} as const;
